/**
 * URL处理模块
 * @module url
 */
// import { pathToRegexp, match, parse, compile } from 'path-to-regexp';
import { URL } from './regex';
import MD5 from 'crypto-js/md5';

const salt = 'COIRcLlO2CxFHurPM8qK1KTq'; // 开启token加密

// export {
//   pathToRegexp,
//   match,
//   parse,
//   compile
// };

/**
 * 获取当前页面的 host
 * @param {boolean} includePath 带上 pathname
 * @return {string}
 */
export function getCurrentHost(includePath) {
  const {protocol, host, pathname} = location;
  return `${protocol}//${host}${includePath ? pathname : ''}`;
}

/**
 * 获取指定url的host
 * @param {string} url
 * @return {string} host
 */
export function getHost(url = '') {
  const matches = url.match(URL);
  if (matches) {
    return matches[0];
  }
  return '';
}

/**
 * 键值对转换成查询字符串
 * @param {object} query 键值对，对象
 * @returns {string} 查询参数字符串
 */
export function stringify(query) {
  const array = [];
  for (const key in query) {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      array.push([key, encodeURIComponent(query[key])].join('='));
    }
  }
  return array.join('&');
}

/**
 * 参数字符串转换成对象形式，如：a=1&b=2 转换成 {a:1, b:2}
 * @param {String} str 需要转换的字符串
 * @param {String} [sep=&] 连接符，可选，默认 &
 * @param {String} [eq==] 键值间隔符，可选，默认 =
 * @returns {Object}
 */
export function getQuery(str, sep, eq) {
  const obj = {};
  str = (str || location.search).replace(/^[^]*\?/, '');
  sep = sep || '&';
  eq = eq || '=';
  let arr;
  const reg = new RegExp('(?:^|\\' + sep + ')([^\\' + eq + '\\' + sep + ']+)(?:\\' + eq + '([^\\' + sep + ']*))?', 'g');
  while ((arr = reg.exec(str)) !== null) {
    if (arr[1] !== str) {
      obj[decodeURIComponent(arr[1])] = decodeURIComponent(arr[2] || '');
    }
  }
  return obj;
}

/**
 * 从url 的 path中提取参数对象，
 * @param {string} regexPath url path规则表达式
 * @param {string} path URL
 * @param {object} [opt]
 * @returns {object} 参数键值对
 *
 * @example
 *
 * let regexUrl = '/api/:type/:id' ,
 *     url = '/api/abc/123'
 * getParams(regexUrl, url) // -> {type: 'abc', id: 123}
 *
 */
// export function getParams(regexPath, path = '', opt = {decode: decodeURIComponent}) {
//   const host = getHost(regexPath);
//   const matched = match(regexPath.replace(host, ''), opt);
//   const result = matched(path.split('?')[0].replace(host, ''));
//   return result?.params || {};
// }

/**
 * 在url追加参数
 * @param {string} url 原本的url
 * @param {string|object} query 需要追加的参数，Object|String
 * @returns {string} 追加参数后的url
 */
export function appendQuery(url, query) {
  query = typeof query === 'string' ? getQuery(query) : query;
  const path = url.split('?')[0];
  const originalQuery = getQuery(url);
  const joinQuery = Object.assign({}, originalQuery, query);
  const queryStr = stringify(joinQuery);
  return queryStr ? [path, queryStr].join('?') : url;
}

export const getUrlWithSign = (path) => {
  const token = this.getToken();
  const sign = String(MD5([path, token, salt].join(',')));
  return appendQuery(path, {
    __sign__: sign
  });
}

export default {
  getCurrentHost,
  getHost,
  stringify,
  getQuery,
  // getParams,
  appendQuery,
  getUrlWithSign
};
